/* eslint-disable max-len */
import React from 'react';
//////////////////////////////////////////////////

const accessorial = (color, width, height) => (
  <svg
    viewBox='0 0 24 24'
    width={width || 20}
    height={height || 20}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#015295'}
      d='M12.549 18.906A6.91 6.91 0 0 0 19.455 12a6.91 6.91 0 0 0-6.906-6.906c-1.989 0-3.781.842-5.04 2.184-1.156 1.234-1.866 2.895-1.866 4.717a6.91 6.91 0 0 0 6.906 6.911zm-2.41-4.173l.196-.676c.083-.26.152-.294.392-.167.411.216.842.333 1.298.392a1.63 1.63 0 0 0 .852-.113c.509-.22.588-.808.157-1.166-.147-.122-.313-.211-.485-.284-.446-.196-.911-.343-1.327-.598-.681-.407-1.117-.97-1.063-1.798.059-.94.588-1.523 1.45-1.837.353-.127.358-.122.358-.495v-.377c.005-.279.054-.328.333-.338.088-.005.171 0 .26 0 .593 0 .593 0 .598.593 0 .421 0 .421.421.485a3.56 3.56 0 0 1 .921.274c.162.073.225.186.176.358l-.225.769c-.078.24-.152.274-.382.162a2.91 2.91 0 0 0-1.46-.289 1.1 1.1 0 0 0-.392.078c-.441.191-.514.681-.137.984.191.152.407.264.632.358l1.156.524c1.185.656 1.504 2.14.671 3.154a2.25 2.25 0 0 1-1.151.74c-.201.054-.289.162-.279.367v.612a.25.25 0 0 1-.274.284h-.656c-.191-.005-.284-.113-.284-.299l-.005-.446c-.005-.328-.015-.343-.328-.392-.407-.064-.803-.157-1.171-.338-.304-.147-.333-.22-.25-.524zm9.889 4.751a10.6 10.6 0 0 1-14.537.407h1.332v-1.42H4.021h-.034-.945v.96.02 2.802h1.42v-1.376C6.744 22.957 9.644 24 12.544 24c3.076 0 6.147-1.171 8.488-3.512l.504-.504-1.004-1.004-.504.504zm.607-17.735v1.376C18.353 1.043 15.453 0 12.553 0 9.478 0 6.407 1.171 4.065 3.512l-.5.5L4.57 5.016l.504-.504a10.6 10.6 0 0 1 14.537-.407h-1.332v1.42h2.802.034.945v-.96-.02-2.797h-1.425z'
    />
  </svg>
);

const addChild = (color, width, height) => (
  <svg
    viewBox='0 0 15 15'
    width={width || 15}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill='none'>
      <path
        fill={color || '#930000'}
        d='M6.372.013a.22.22 0 0 0-.22.219v1.965H3.296a.22.22 0 1 0 0 .44h.22V7.03H1.099a.659.659 0 1 0-.22 1.278v5.314h-.66a.22.22 0 1 0 0 .44h13.624a.22.22 0 1 0 0-.44h-.66v-7.47h.22a.22.22 0 1 0 0-.44h-1.977v-.44a.44.44 0 0 0-.44-.439h-.879V2.637h.22a.22.22 0 1 0 0-.44H7.471V1.33a.22.22 0 0 0-.44 0v.867h-.44V.232a.22.22 0 0 0-.219-.22zM3.955 2.637h5.713v10.986H3.955V2.637zm1.099.879a.22.22 0 0 0-.22.22v1.318a.22.22 0 1 0 .44 0V3.735a.22.22 0 0 0-.22-.22zm1.758 0a.22.22 0 0 0-.22.22v.439a.22.22 0 1 0 .44 0v-.44a.22.22 0 0 0-.22-.22zm1.757 0a.22.22 0 0 0-.22.22v1.318a.22.22 0 1 0 .44 0V3.735a.22.22 0 0 0-.22-.22zM6.812 5.273a.22.22 0 0 0-.22.22v.22a.88.88 0 0 0-.88.879v.22a.88.88 0 0 0 .88.878h.44a.44.44 0 0 1 .439.44v.22a.44.44 0 0 1-.44.44v-.66a.22.22 0 1 0-.44 0v.66a.44.44 0 0 1-.439-.44.22.22 0 1 0-.44 0 .88.88 0 0 0 .88.879v.22a.22.22 0 1 0 .44 0v-.22a.88.88 0 0 0 .878-.88v-.22a.88.88 0 0 0-.879-.878v-.66a.22.22 0 1 0-.44 0v.66a.44.44 0 0 1-.439-.44v-.22a.44.44 0 0 1 .44-.439h.44a.44.44 0 0 1 .439.44.22.22 0 1 0 .44 0 .88.88 0 0 0-.88-.88v-.219a.22.22 0 0 0-.22-.22zm3.295 0h.88v.88h1.757v2.636h-2.197a.22.22 0 1 0 0 .44h2.197v4.394h-2.637v-8.35zm1.1 1.319a.22.22 0 1 0 0 .44h.439a.22.22 0 1 0 0-.44h-.44zM1.098 7.47h2.417v.44H1.099a.22.22 0 0 1 0-.44zm10.107 0a.22.22 0 1 0 0 .44h.44a.22.22 0 1 0 0-.44h-.44zm-9.888.879h2.198v5.273h-.44v-.89a.44.44 0 0 0-.44-.44h-.439a.44.44 0 0 0-.44.44v.89h-.439V8.35zm.88.44a.22.22 0 1 0 0 .439h.439a.22.22 0 1 0 0-.44h-.44zm0 .878a.22.22 0 1 0 0 .44h.439a.22.22 0 1 0 0-.44h-.44zm2.856 0a.22.22 0 0 0-.22.22v1.318a.22.22 0 1 0 .44 0V9.888a.22.22 0 0 0-.22-.22zm3.515 0a.22.22 0 0 0-.22.22v2.636a.22.22 0 1 0 .44 0V9.888a.22.22 0 0 0-.22-.22zm2.637 0a.22.22 0 1 0 0 .44h.44a.22.22 0 1 0 0-.44h-.44zm-9.009.879a.22.22 0 1 0 0 .44h.44a.22.22 0 1 0 0-.44h-.44zm4.615 0a.22.22 0 0 0-.22.22v1.757a.22.22 0 1 0 .44 0v-1.757a.22.22 0 0 0-.22-.22zm4.394 0a.22.22 0 1 0 0 .44h.44a.22.22 0 1 0 0-.44h-.44zm-9.009.879a.22.22 0 1 0 0 .44h.44a.22.22 0 1 0 0-.44h-.44zm9.01 0a.22.22 0 1 0 0 .44h.439a.22.22 0 1 0 0-.44h-.44zm-6.153.44a.22.22 0 0 0-.22.219v.44a.22.22 0 1 0 .44 0v-.44a.22.22 0 0 0-.22-.22zm6.152.439a.22.22 0 1 0 0 .44h.44a.22.22 0 1 0 0-.44h-.44zm-9.009.428h.44v.879h-.44v-.879z'
      />
      <circle
        r='3.281'
        cx='11.719'
        cy='11.719'
        strokeWidth='.7'
        stroke={color || '#930000'}
      />
      <path
        fill={color || '#930000'}
        d='M13.728 11.384h-1.674V9.71a.335.335 0 0 0-.67 0v1.674H9.71a.335.335 0 0 0 0 .67h1.674v1.674a.335.335 0 0 0 .67 0v-1.674h1.674a.335.335 0 0 0 0-.67z'
      />
    </g>
  </svg>
);

const addDriverPay = (color, width, height, plusBg, plusColor) => (
  <svg
    viewBox='0 0 16 16'
    width={width || 16}
    height={height || 16}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#930000'}
      d='M10.359 6.062c.133-.341.205-.785.205-1.379C10.563 1.666 8.81 0 5.634 0S.704 1.666.704 4.683c0 .594.071 1.038.205 1.379C.354 6.446 0 6.929 0 7.524c0 .758.265 1.031.876 1.094.217 3.05 2.258 5.445 4.758 5.445s4.541-2.395 4.758-5.445c.611-.063.876-.336.876-1.094 0-.595-.354-1.078-.909-1.462zM5.634.703c2.804 0 4.225 1.339 4.225 3.98 0 .457-.04.781-.119 1.026-1.15-.537-2.754-.787-4.106-.787s-2.956.25-4.106.787c-.079-.244-.119-.568-.119-1.026 0-2.641 1.422-3.98 4.225-3.98zm0 12.656c-2.111 0-3.843-2.081-4.053-4.736l4.053-.232c1.842 0 3.158.185 4.053.232-.21 2.655-1.942 4.736-4.053 4.736zm4.893-5.484c-.017.01-.116.056-.469.056-.318 0-.726-.036-1.242-.081l-3.181-.163a34.24 34.24 0 0 0-3.181.163l-1.242.081c-.346 0-.449-.045-.457-.045-.001 0-.049-.078-.049-.363 0-1.119 2.598-1.899 4.93-1.899s4.93.78 4.93 1.899c0 .261-.04.349-.037.352zM6.988 2.096H4.193a.7.7 0 0 0-.699.699v.699a.7.7 0 0 0 .699.699h2.795a.7.7 0 0 0 .699-.699v-.699a.7.7 0 0 0-.699-.699zm0 1.398H4.193v-.699h2.795v.699z'
    />
    <circle
      r='4.219'
      cx='11.219'
      cy='11.219'
      strokeWidth='0.5'
      fill={plusBg || '#fff'}
      stroke={color || '#930000'}
    />
    <path
      fill={plusColor || '#930000'}
      d='M13.065 10.876h-1.563V9.313c0-.173-.14-.313-.313-.313s-.313.14-.313.313v1.563H9.313c-.173 0-.313.14-.313.313s.14.313.313.313h1.563v1.563c0 .173.14.313.313.313s.313-.14.313-.313v-1.563h1.563c.173 0 .313-.14.313-.313s-.14-.313-.313-.313z'
    />
  </svg>
);

const amousNewTxtLogo = (color, width, height) => (
  <svg
    viewBox='0 0 285 54'
    width={width || 285}
    height={height || 54}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path fill='#000' d='M43.268 3.668h6.868v49.057h-6.868l-.245-9.124a19.96 19.96 0 0 1-6.721 7.555C33.424 53.052 29.99 54 26 54c-3.597 0-6.966-.67-10.106-2.011a26.81 26.81 0 0 1-8.291-5.642 26.12 26.12 0 0 1-5.592-8.291C.67 34.917 0 31.548 0 27.951c0-3.532.654-6.852 1.962-9.958 1.341-3.107 3.172-5.838 5.494-8.192a25.56 25.56 0 0 1 8.143-5.494c3.107-1.341 6.426-2.011 9.958-2.011 4.088 0 7.653.981 10.694 2.943 3.041 1.93 5.462 4.464 7.26 7.604l-.245-9.174zm-17.415 43.66c3.499 0 6.508-.85 9.026-2.551 2.518-1.733 4.448-4.055 5.789-6.966 1.374-2.911 2.06-6.116 2.06-9.615 0-3.597-.687-6.835-2.06-9.713-1.374-2.911-3.32-5.216-5.838-6.917s-5.511-2.551-8.977-2.551-6.639.867-9.517 2.6c-2.845 1.701-5.118 4.006-6.819 6.917-1.668 2.911-2.502 6.132-2.502 9.664 0 3.565.867 6.802 2.6 9.713a19.73 19.73 0 0 0 6.868 6.868 18.09 18.09 0 0 0 9.37 2.551zm34.1 5.397V3.668h6.868v6.77c1.766-2.485 4.023-4.464 6.77-5.936s5.756-2.208 9.026-2.208c3.696 0 7.081.916 10.155 2.747 3.074 1.799 5.478 4.203 7.211 7.211 1.733-3.009 4.12-5.413 7.162-7.211 3.041-1.831 6.41-2.747 10.106-2.747s7.064.899 10.105 2.698 5.462 4.219 7.261 7.26 2.698 6.41 2.698 10.106v30.366h-6.868V23.879c0-2.616-.638-5.036-1.913-7.26a14.96 14.96 0 0 0-5.151-5.347c-2.126-1.374-4.497-2.06-7.114-2.06s-5.003.638-7.162 1.913c-2.126 1.243-3.826 2.976-5.102 5.2-1.275 2.191-1.913 4.709-1.913 7.555v28.845h-6.868V23.879c0-2.845-.638-5.364-1.913-7.555-1.276-2.224-2.993-3.957-5.151-5.2-2.159-1.275-4.546-1.913-7.162-1.913-2.584 0-4.955.687-7.113 2.06a14.95 14.95 0 0 0-5.151 5.347c-1.275 2.224-1.913 4.644-1.913 7.26v28.845h-6.868zM167.77 54c-4.514 0-8.634-1.161-12.363-3.483-3.695-2.322-6.655-5.429-8.879-9.321-2.191-3.924-3.287-8.258-3.287-13 0-3.597.638-6.95 1.914-10.057 1.275-3.14 3.025-5.887 5.249-8.241 2.256-2.387 4.873-4.252 7.849-5.592s6.148-2.011 9.517-2.011c4.513 0 8.617 1.161 12.313 3.483 3.728 2.322 6.688 5.445 8.879 9.37 2.224 3.925 3.336 8.274 3.336 13.049 0 3.565-.638 6.901-1.913 10.008s-3.042 5.854-5.298 8.242c-2.224 2.355-4.824 4.202-7.8 5.543-2.944 1.34-6.116 2.01-9.517 2.01zm0-6.868c3.336 0 6.328-.867 8.977-2.6 2.682-1.766 4.791-4.088 6.328-6.966 1.57-2.878 2.355-6.001 2.355-9.37 0-3.434-.785-6.59-2.355-9.468-1.569-2.911-3.695-5.233-6.377-6.966-2.649-1.733-5.625-2.6-8.928-2.6-3.336 0-6.345.883-9.027 2.649-2.649 1.733-4.758 4.039-6.328 6.917-1.537 2.878-2.306 6.034-2.306 9.468 0 3.532.802 6.737 2.404 9.615 1.603 2.845 3.745 5.118 6.427 6.819a16.39 16.39 0 0 0 8.83 2.502zm30.396-13.196V3.668h6.868v28.894c0 2.682.654 5.118 1.962 7.309a14.94 14.94 0 0 0 5.249 5.249c2.224 1.308 4.66 1.962 7.309 1.962 2.682 0 5.102-.654 7.261-1.962a14.94 14.94 0 0 0 5.249-5.249c1.308-2.191 1.962-4.628 1.962-7.309V3.668h6.868l.049 49.057h-6.868l-.049-6.868c-1.733 2.486-3.99 4.464-6.77 5.936C224.509 53.264 221.5 54 218.23 54c-3.696 0-7.064-.899-10.106-2.698a20.32 20.32 0 0 1-7.26-7.26c-1.799-3.041-2.698-6.41-2.698-10.106zm67.71 19.721c-2.682-.065-5.298-.556-7.849-1.472s-4.775-2.158-6.672-3.728-3.254-3.352-4.071-5.347l5.935-2.551c.524 1.276 1.488 2.453 2.895 3.532 1.439 1.046 3.074 1.897 4.905 2.551 1.832.621 3.647.932 5.446.932 1.995 0 3.859-.327 5.592-.981s3.14-1.586 4.219-2.796c1.112-1.243 1.668-2.698 1.668-4.366 0-1.799-.589-3.205-1.766-4.219-1.178-1.047-2.666-1.864-4.464-2.453l-5.544-1.766c-3.466-.948-6.524-1.995-9.173-3.14s-4.726-2.6-6.23-4.366c-1.472-1.799-2.208-4.104-2.208-6.917 0-2.976.834-5.543 2.502-7.702 1.701-2.191 3.908-3.875 6.623-5.053C260.431 2.605 263.358 2 266.465 2c3.99 0 7.62.867 10.89 2.6 3.303 1.733 5.691 4.039 7.162 6.917l-5.543 3.287c-.589-1.341-1.521-2.502-2.796-3.483s-2.731-1.75-4.366-2.306a15.83 15.83 0 0 0-4.906-.883c-2.093-.033-4.039.278-5.838.932-1.798.621-3.254 1.553-4.366 2.796-1.079 1.243-1.618 2.764-1.618 4.562s.539 3.172 1.618 4.121c1.08.916 2.535 1.668 4.366 2.257l6.28 1.962c2.976.948 5.772 2.028 8.388 3.238s4.726 2.715 6.329 4.513 2.387 4.072 2.354 6.819c0 2.943-.883 5.511-2.649 7.702s-4.055 3.875-6.868 5.053c-2.812 1.145-5.821 1.668-9.026 1.57z' />
    <circle cx='182.353' cy='10.539' r='4.986' fill='#bff22e' />
    <circle cx='182.353' cy='10.539' r='7.486' fill='none' stroke='#bff22e' />
  </svg>
);

const analysis = (color, width, height) => (
  <svg
    viewBox='0 0 15 15'
    width={width || 15}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={color || '#930000'}>
      <path d='M14.323.34a1.131 1.131 0 0 0-.802-.34h-.01c-.622 0-1.132.506-1.138 1.129-.002.304.114.59.327.807s.498.338.802.34h.01a1.14 1.14 0 0 0 1.138-1.128 1.131 1.131 0 0 0-.327-.808zm-.811 1.516h-.006A.713.713 0 0 1 13 1.642.72.72 0 0 1 13.511.42h.007a.713.713 0 0 1 .505.214.72.72 0 0 1-.511 1.221zM1.148 6.187h-.01A1.14 1.14 0 0 0 0 7.316a1.14 1.14 0 0 0 1.129 1.147h.01c.622 0 1.132-.506 1.138-1.129a1.14 1.14 0 0 0-1.13-1.147zm-.01 1.856h-.006a.719.719 0 0 1 .006-1.436h.006a.719.719 0 0 1-.006 1.436zm4.293-6.14h-.01a1.14 1.14 0 0 0-.01 2.277h.01a1.14 1.14 0 0 0 .01-2.277zm-.01 1.856h-.005a.719.719 0 0 1 .006-1.435h.006a.719.719 0 0 1-.006 1.435zm3.104 1.238h-.01a1.14 1.14 0 0 0-1.138 1.128 1.14 1.14 0 0 0 1.129 1.148h.01a1.14 1.14 0 0 0 .01-2.277zm-.01 1.856H8.51a.719.719 0 0 1 .006-1.436h.006a.719.719 0 0 1-.006 1.436z' />
      <path d='M9.022 5.33L12.7 1.641l.708.707-3.68 3.688zM5.93 3.847l.706-.708 1.782 1.782-.707.708zM1.646 6.52l2.971-2.971.707.707-2.971 2.971zM12.064 4.33v10.32h2.586V4.33h-2.586zm.42 9.9V4.75h1.745v9.478h-1.744zM8.043 8.661v5.989h2.586V8.66H8.043zm2.165 5.568H8.463V9.082h1.745v5.147zM4.021 8.352v6.298h2.586V8.352H4.021zm2.166 5.877H4.442V8.773h1.745v5.456zM0 9.899v4.75h2.586V9.9H0zm2.165 4.33H.421v-3.91h1.744v3.91z' />
    </g>
  </svg>
);

const analytic = (color, width, height) => (
  <svg
    viewBox='0 0 15 15'
    width={width || 15}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#930000'}
      d='M14.735 6.876A7.4 7.4 0 0 0 7.885.027L7.624.009v7.13h7.13l-.018-.263zm-7.034.754l4.942 4.943.174-.189a7.39 7.39 0 0 0 1.936-4.49l.018-.263h-7.07zm4.924 4.23L8.888 8.123h5.352c-.151 1.38-.713 2.682-1.615 3.737zM7.131.01L6.87.026A7.4 7.4 0 0 0 0 7.385c0 1.78.645 3.5 1.815 4.843l.173.199L7.13 7.283V.01zM6.64 7.08l-4.623 4.623A6.88 6.88 0 0 1 .492 7.385C.492 3.868 3.172.91 6.639.54v6.54zm-4.304 5.694l.198.173a7.371 7.371 0 0 0 9.524.136l.21-.172-5.035-5.034-4.897 4.897zm4.897-4.202l.27.27-4.132 4.134-.312-.23 4.174-4.174zm-2.02 5.344a6.8 6.8 0 0 1-.505-.19l3.839-3.84.348.348-3.682 3.682zm4.03-3.334l.347.347-3.257 3.257a6.81 6.81 0 0 1-.58-.115l3.49-3.49zm-5.009 2.921a6.822 6.822 0 0 1-.445-.25L7.851 9.19l.348.348-3.965 3.964zm2.729.75l2.975-2.976.348.348-2.634 2.634-.275.011c-.139 0-.276-.01-.414-.018zm3.67-2.28l.348.348-1.663 1.663a6.884 6.884 0 0 1-.9.204l2.215-2.215zm-.167 1.559l.863-.864.204.204a6.86 6.86 0 0 1-1.067.66z'
    />
  </svg>
);

const analytic2 = (color, width, height) => (
  <svg
    viewBox='0 0 14 14'
    width={width || 14}
    height={height || 14}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#fff'}
      d='M7.088.653c-.178.115-.17-.036-.17 3.032v2.786l.063.093c.134.202-.074.189 3.046.183l2.871-.066a.61.61 0 0 0 .129-.148c.049-.085.052-.112.022-.407a6.18 6.18 0 0 0-.968-2.751c-.561-.87-1.477-1.684-2.414-2.155C9.015.897 8.124.651 7.479.615 7.205.599 7.17.602 7.088.653zm-1.455.433c-.271.022-.798.12-1.127.211a6.21 6.21 0 0 0-4.353 4.59c-.112.498-.139.766-.137 1.359A5.7 5.7 0 0 0 .645 9.97c.495 1.017 1.312 1.914 2.294 2.527a6.22 6.22 0 0 0 6.166.172c.448-.243 1.105-.719 1.209-.88.079-.115.066-.303-.03-.429A125.48 125.48 0 0 0 8.23 9.285L6.218 7.241c-.033-.063-.038-.506-.038-2.953l-.055-2.997c-.041-.09-.079-.129-.17-.17-.066-.03-.137-.052-.159-.049l-.164.014zM8.6 7.601a.4.4 0 0 0-.205.26c-.049.224-.09.178 1.704 1.977l1.805 1.788c.104.09.159.115.26.123.17.014.232-.022.424-.252.777-.921 1.25-2.056 1.389-3.325.027-.26.027-.301-.016-.388a.42.42 0 0 0-.137-.156c-.088-.055-.129-.055-2.628-.052L8.6 7.601z'
    />
  </svg>
);

const analyticMaps = (color, width, height) => (
  <svg
    viewBox='0 0 15 15'
    width={width || 15}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#015295'}
      d='M12.314 9.25h-1.756l.747-1.1c1.412-1.918 1.207-5.07-.436-6.746A4.626 4.626 0 0 0 7.543 0a4.627 4.627 0 0 0-3.325 1.404C2.574 3.08 2.37 6.232 3.776 8.142l.752 1.108H2.686L0 15h15l-2.686-5.75zM7.587 3c.946 0 1.716.785 1.716 1.75S8.533 6.5 7.587 6.5 5.87 5.715 5.87 4.75 6.64 3 7.587 3zM2.996 9.75h1.872l2.675 3.94 2.676-3.94h1.785l2.22 4.75H.776l2.219-4.75z'
    />
  </svg>
);

const analyticMaps2 = (color, width, height) => (
  <svg
    viewBox='0 0 14 14'
    width={width || 14}
    height={height || 14}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#fff'}
      d='M6.604.019C5.291.175 4.211.828 3.497 1.895c-.602.9-.837 2.073-.599 3C3.183 6.01 3.973 7.53 5.305 9.529L7 11.892c.038 0 1.195-1.613 1.712-2.39 1.523-2.286 2.346-3.976 2.472-5.075.049-.418-.046-1.105-.219-1.597-.541-1.534-1.881-2.606-3.5-2.803-.219-.025-.681-.03-.861-.008zm.826 2.855c.703.227 1.113.984.916 1.695a1.43 1.43 0 0 1-1.132 1.009 1.41 1.41 0 0 1-1.608-1.359c0-.965.911-1.635 1.824-1.345zM2.256 7.856C1.195 8.37.435 9.059.148 9.762c-.358.881-.046 1.84.837 2.579 1.203 1.004 3.158 1.589 5.537 1.649 2.827.074 5.474-.64 6.683-1.807.514-.498.749-.96.787-1.559.068-1.075-.755-2.048-2.313-2.74l-.26-.112-.227.427-.356.629c-.068.109-.12.202-.115.208s.131.052.276.109c.984.383 1.589.9 1.591 1.356.003.736-1.575 1.597-3.53 1.928-2.231.38-4.736.109-6.366-.684-.829-.405-1.282-.845-1.282-1.244 0-.421.503-.889 1.446-1.343l.416-.202c.005-.003-.074-.139-.172-.304l-.342-.621-.183-.32a4.68 4.68 0 0 0-.32.145z'
    />
  </svg>
);

const arrowDollarMinus = (color, width, height) => (
  <svg
    viewBox='0 0 24 22'
    width={width || 24}
    height={height || 18}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#CE2929'}
      d='M8.51 9.69c-.84-.462-1.731-.814-2.614-1.18-.512-.211-1.002-.458-1.434-.802-.852-.678-.689-1.78.309-2.216.282-.123.578-.163.878-.18a6.68 6.68 0 0 1 3.302.651c.52.251.693.172.87-.37l.511-1.731c.115-.388-.026-.644-.393-.807-.67-.295-1.36-.506-2.083-.62-.945-.146-.945-.15-.95-1.098C6.903.002 6.903.002 5.562.002c-.195 0-.389-.004-.583 0-.627.018-.733.128-.75.758l-.005.85c-.004.837-.009.824-.812 1.115C1.469 3.43.268 4.752.141 6.867c-.115 1.872.864 3.137 2.405 4.058.949.568 2 .903 3.006 1.348.393.172.768.37 1.094.643.967.798.79 2.124-.357 2.626-.614.269-1.262.335-1.929.251-1.028-.128-2.013-.396-2.94-.877-.543-.282-.701-.207-.887.38l-.441 1.528c-.19.688-.12.85.538 1.172.839.406 1.735.613 2.649.758.715.115.737.145.746.886l.008 1.009c.005.423.208.67.645.678l1.487-.004c.406-.009.614-.23.614-.64l.004-1.378c-.022-.467.181-.705.632-.829 1.037-.282 1.92-.837 2.6-1.665 1.889-2.291 1.17-5.644-1.506-7.12zm15.467 2.136c-.046-.166-.154-.274-.274-.274h-3.25V.444C20.453.2 20.32 0 20.157 0H15.41c-.164 0-.296.2-.296.444v11.108h-3.263c-.12 0-.228.108-.274.273a.62.62 0 0 0 .064.485l5.917 8.893c.056.083.131.13.21.13s.154-.047.21-.13l5.934-8.892c.085-.128.11-.319.064-.485z'
    />
  </svg>
);

const arrowDollarPlus = (color, width, height) => (
  <svg
    viewBox='0 0 24 22'
    width={width || 24}
    height={height || 18}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#1E9109'}
      d='M8.51 9.69c-.84-.462-1.731-.814-2.614-1.18-.512-.211-1.002-.458-1.434-.802-.852-.678-.689-1.78.309-2.216.282-.123.578-.163.878-.18a6.68 6.68 0 0 1 3.302.651c.52.251.693.172.87-.37l.511-1.731c.115-.388-.026-.644-.393-.807-.67-.295-1.36-.506-2.083-.62-.945-.146-.945-.15-.95-1.098C6.902.002 6.902.002 5.561.002c-.195 0-.389-.004-.583 0-.627.018-.733.128-.75.758l-.005.85c-.004.837-.009.824-.812 1.115C1.469 3.43.268 4.752.141 6.867c-.115 1.872.864 3.137 2.405 4.058.949.568 2 .903 3.006 1.348.393.172.768.37 1.094.643.967.798.79 2.124-.357 2.626-.614.269-1.262.335-1.929.251-1.028-.128-2.013-.396-2.94-.877-.543-.282-.701-.207-.887.38l-.441 1.528c-.19.688-.12.85.538 1.172.839.406 1.735.613 2.649.758.715.115.737.145.746.886l.008 1.009c.005.423.208.67.645.678l1.487-.004c.406-.009.614-.23.614-.64l.004-1.378c-.022-.467.181-.705.632-.829 1.037-.282 1.92-.837 2.6-1.665 1.889-2.291 1.17-5.644-1.506-7.12zm3.068-.183c.047.166.155.275.274.275h3.25v11.107c0 .245.133.444.297.444h4.745c.164 0 .297-.199.297-.444V9.782h3.262c.12 0 .228-.109.274-.274s.021-.357-.064-.484L17.996.13c-.055-.084-.13-.131-.21-.131s-.154.047-.21.13l-5.934 8.893c-.084.127-.11.318-.064.484'
    />
  </svg>
);

const arrowDown = (color, width, height) => (
  <svg
    viewBox='0 0 8 12'
    width={width || 8}
    height={height || 12}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#353535'}
      d='M6.896 7.23a.524.524 0 0 1 .793 0 .663.663 0 0 1 0 .865l-3.325 3.628a.547.547 0 0 1-.405.182.549.549 0 0 1-.405-.182L.23 8.095a.646.646 0 0 1 0-.866.524.524 0 0 1 .794 0l2.373 2.598V.606c0-.338.254-.606.563-.606s.555.268.555.606v9.22L6.896 7.23z'
    />
  </svg>
);

const arrowDownBold = (color, width, height) => (
  <svg
    width={width || 20}
    viewBox='0 0 512 512'
    height={height || 20}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#353535'}
      d='M383.6 322.7L278.6 423c-5.8 6-13.7 9-22.4 9s-16.5-3-22.4-9L128.4 322.7c-12.5-11.9-12.5-31.3 0-43.2s32.7-11.9 45.2 0l50.4 48.2v-217c0-16.9 14.3-30.6 32-30.6s32 13.7 32 30.6v217l50.4-48.2c12.5-11.9 32.7-11.9 45.2 0s12.5 31.2 0 43.2z'
    />
  </svg>
);

const arrowDownSimple = (color, width, height) => (
  <svg
    viewBox='0 0 11 7'
    width={width || 11}
    height={height || 7}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      stroke={color || '#fff'}
      d='M9.967 1.094a.32.32 0 0 0-.453 0l-3.98 3.988-3.988-3.988a.32.32 0 0 0-.452.452L5.3 5.753c.063.062.14.093.226.093a.326.326 0 0 0 .227-.093l4.206-4.207a.314.314 0 0 0 .008-.452z'
    />
  </svg>
);

const arrowDownSimple2 = (color, width, height) => (
  <svg
    viewBox='0 0 14 14'
    width={width || 14}
    height={height || 14}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#fff'}
      d='M3.711 6.71l2.59 2.59c.39.39 1.02.39 1.41 0l2.59-2.59c.63-.63.18-1.71-.71-1.71h-5.18c-.89 0-1.33 1.08-.7 1.71z'
    />
  </svg>
);

const arrowIconMob = (color, width, height) => (
  <svg
    viewBox='0 0 16 16'
    width={width || 16}
    height={height || 16}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#fff'}
      d='M16 7H3.83l5.59-5.59L8 0 0 8l8 8 1.41-1.41L3.83 9H16z'
    />
  </svg>
);

const arrowUndo = (color, width, height) => (
  <svg
    viewBox='0 0 12 15'
    width={width || 12}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#fff'}
      d='M11.719 9.361A5.648 5.648 0 0 1 6.074 15H4.076a.599.599 0 0 1-.6-.599v-.2a.6.6 0 0 1 .6-.598h1.998A4.249 4.249 0 0 0 10.32 9.36a4.249 4.249 0 0 0-4.246-4.24H2.388l2.538 2.537a.699.699 0 0 1 0 .988.717.717 0 0 1-.989 0L.205 4.914A.694.694 0 0 1 0 4.422c0-.187.073-.362.205-.494L3.938.197a.717.717 0 0 1 .988 0 .699.699 0 0 1 0 .989L2.388 3.722h3.686a5.648 5.648 0 0 1 5.645 5.64z'
    />
  </svg>
);

const arrowUp = (color, width, height) => (
  <svg
    viewBox='0 0 8 12'
    width={width || 8}
    height={height || 12}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#353535'}
      d='M1.104 4.77a.524.524 0 0 1-.793 0 .663.663 0 0 1 0-.865L3.636.277a.547.547 0 0 1 .405-.182.55.55 0 0 1 .405.182L7.77 3.905a.646.646 0 0 1 0 .866.524.524 0 0 1-.794 0L4.604 2.173v9.221c0 .338-.254.606-.563.606s-.556-.268-.556-.606v-9.22L1.106 4.77z'
    />
  </svg>
);

const arrowUpBold = (color, width, height) => (
  <svg
    width={width || 20}
    height={height || 20}
    viewBox='0 0 512 512'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#353535'}
      d='M128.4 189.3L233.4 89c5.8-6 13.7-9 22.4-9s16.5 3 22.4 9l105.4 100.3c12.5 11.9 12.5 31.3 0 43.2s-32.7 11.9-45.2 0L288 184.4v217c0 16.9-14.3 30.6-32 30.6s-32-13.7-32-30.6v-217l-50.4 48.2c-12.5 11.9-32.7 11.9-45.2 0-12.5-12-12.5-31.3 0-43.3z'
    />
  </svg>
);

const arrowUpSimple = (color, width, height) => (
  <svg
    viewBox='0 0 11 7'
    width={width || 11}
    height={height || 7}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      stroke={color || '#fff'}
      d='M1.093 5.753a.32.32 0 0 0 .452 0l3.98-3.988 3.988 3.988a.32.32 0 0 0 .453-.453L5.76 1.094A.313.313 0 0 0 5.533 1a.326.326 0 0 0-.226.094L1.101 5.3a.314.314 0 0 0-.008.453z'
    />
  </svg>
);

const arrowUpSimple2 = (color, width, height) => (
  <svg
    viewBox='0 0 14 14'
    width={width || 14}
    height={height || 14}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#fff'}
      d='M10.29 7.29L7.699 4.7c-.39-.39-1.02-.39-1.41 0l-2.59 2.59c-.63.63-.18 1.71.71 1.71h5.18c.89 0 1.33-1.08.7-1.71z'
    />
  </svg>
);

const assignRole = (color, width, height) => (
  <svg
    viewBox='0 0 13 15'
    width={width || 13}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={color || '#930000'}>
      <path d='M10.916 0H4.055a.314.314 0 0 0-.221.091L.091 3.834a.314.314 0 0 0-.09.22v9.357c0 .172.139.312.311.312h3.876a.312.312 0 0 0 0-.624H.624V4.184l3.56-3.56h6.42v4.064a.312.312 0 0 0 .624 0V.312A.312.312 0 0 0 10.916 0z' />
      <path d='M4.055 0a.312.312 0 0 0-.312.312v3.43H.313a.312.312 0 0 0 0 .624h3.742c.172 0 .312-.14.312-.311V.312A.312.312 0 0 0 4.055 0z' />
      <g
        strokeWidth='.1'
        stroke={color || '#930000'}
      >
        <path d='M6.161 6.45c0 .595.24 1.283.641 1.838.456.631 1.033.979 1.623.979s1.168-.348 1.624-.979c.401-.555.64-1.243.64-1.838 0-1.212-1.015-2.199-2.264-2.199s-2.264.987-2.264 2.199zm2.264-1.817c1.032 0 1.872.815 1.872 1.817 0 .512-.219 1.132-.57 1.619-.375.518-.85.816-1.302.816s-.926-.298-1.3-.816c-.352-.487-.57-1.107-.57-1.62 0-1 .839-1.816 1.87-1.816z' />
        <path d='M10.115 8.84a.201.201 0 0 0-.223.037c-.44.426-.947.651-1.467.651s-1.026-.225-1.466-.65a.201.201 0 0 0-.223-.038 3.91 3.91 0 0 0-1.62 1.385 3.727 3.727 0 0 0-.626 2.067v.003c0 .054.024.105.065.141a5.848 5.848 0 0 0 3.87 1.45 5.848 5.848 0 0 0 3.87-1.45.188.188 0 0 0 .065-.141v-.003c0-.736-.216-1.451-.624-2.067a3.908 3.908 0 0 0-1.62-1.385zm-1.69 4.664a5.45 5.45 0 0 1-3.54-1.294 3.354 3.354 0 0 1 .56-1.778 3.515 3.515 0 0 1 1.34-1.189c.491.437 1.056.667 1.64.667s1.15-.23 1.642-.667a3.515 3.515 0 0 1 1.338 1.189c.353.531.546 1.144.561 1.778a5.45 5.45 0 0 1-3.54 1.294z' />
      </g>
      <path d='M4.367 6.06a.162.162 0 0 0-.252 0 .223.223 0 0 0 0 .284l1.278 1.454H1.176c-.098 0-.176.089-.176.2s.078.204.176.204h4.217L4.115 9.653a.227.227 0 0 0 0 .287c.07.08.184.08.252 0l1.58-1.798a.217.217 0 0 0 0-.284L4.367 6.06z' />
    </g>
  </svg>
);

const average = (color, width, height) => (
  <svg
    viewBox='0 0 20 24'
    width={width || 17}
    height={height || 21}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#015295'}
      d='M19.191 6.371h-.266l-.677-1.906c-.064-.182-.21-.323-.393-.382l-.871-.282a.62.62 0 0 0-.779.399.62.62 0 0 0 .399.778l.58.188.428 1.205h-.184a.31.31 0 0 0-.282.183l-.5 1.113c-.021.045-.03.095-.028.144l.189 3.401a.31.31 0 0 0 .309.292h.192v7.374a2.14 2.14 0 0 1-1.15 1.896v-4.6a1.85 1.85 0 0 0-.433-1.19V2.304A2.31 2.31 0 0 0 13.42 0H2.768A2.31 2.31 0 0 0 .463 2.305v12.679a1.85 1.85 0 0 0-.434 1.19v5.97A1.86 1.86 0 0 0 1.885 24h12.418a1.86 1.86 0 0 0 1.833-1.566c1.564-.426 2.719-1.858 2.719-3.556v-7.373h.336a.31.31 0 0 0 .31-.31V6.681a.31.31 0 0 0-.31-.31zM8.094 16.863c-1.449 0-2.623-1.175-2.623-2.623s2.623-4.22 2.623-4.22 2.622 2.772 2.622 4.22-1.174 2.623-2.622 2.623zM13.25 6.617H2.937V2.474h10.314v4.143z'
    />
  </svg>
);

export {
  average,
  arrowUp,
  analytic,
  addChild,
  analysis,
  arrowUndo,
  analytic2,
  arrowDown,
  assignRole,
  accessorial,
  arrowUpBold,
  arrowIconMob,
  analyticMaps,
  addDriverPay,
  analyticMaps2,
  arrowDownBold,
  arrowUpSimple,
  arrowUpSimple2,
  amousNewTxtLogo,
  arrowDollarPlus,
  arrowDownSimple,
  arrowDownSimple2,
  arrowDollarMinus,
};
